import * as termsModule from "./latex.terms.mjs";

export const tokenNames = Object.keys(termsModule);

export const Tokens = {
    ctrlSeq: tokenNames.filter((name) => name.match(/^(Begin|End|.*CtrlSeq)$/)),
    ctrlSym: tokenNames.filter((name) => name.match(/^.*CtrlSym$/)),
    envName: tokenNames.filter((name) => name.match(/^.*EnvName$/)),
};
